import { render, staticRenderFns } from "./modulPage.vue?vue&type=template&id=4abeb08e&scoped=true"
import script from "./modulPage.vue?vue&type=script&lang=js"
export * from "./modulPage.vue?vue&type=script&lang=js"
import style0 from "./modulPage.vue?vue&type=style&index=0&id=4abeb08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abeb08e",
  null
  
)

export default component.exports